import React, { Component } from "react";
import {
    Grid,
    NavBar,
    WingBlank,
    WhiteSpace,
    Button,
    ActionSheet,
    Toast,
    NoticeBar,
    Card,
    Icon,
} from "antd-mobile";
import { connect } from "dva";
import axios from "../../service/axios";
import { version } from "@/utils/project";
import "./menu.scss";
import menu_user_list from "../../assets/images/icon/gwsd/menu_user_list.png";
import menu_add_user from "../../assets/images/icon/gwsd/menu_user_add.png";
import menu_user_add from "../../assets/images/icon/menu_user_add.png";
import menu_group_list from "../../assets/images/icon/gwsd/menu_group_list.png";
import menu_group_add from "../../assets/images/icon/gwsd/menu_group_add.png";
import menu_group_combination from "../../assets/images/icon/gwsd/menu_group_combination.png";
import menu_bill_record from "../../assets/images/icon/menu_bill_record.png";
import menu_bill_message from "../../assets/images/icon/gwsd/menu_bill_message.png";
import menu_group_QR from "../../assets/images/icon/gwsd/QRcode.png";
import menu_group_prefix_list from "../../assets/images/icon/gwsd/menu_group_prefix_list.png"
import menu_bill_exchange from "../../assets/images/icon/menu_bill_exchange.png";
import admin_list from "../../assets/images/icon/gwsd/admin_list.png";
import admin_add from "../../assets/images/icon/gwsd/admin_add.png";
import menu_saoyisao from "../../assets/images/saoyisao.png";
import menu_recycle_bin from "../../assets/images/icon/gwsd/recycle_bin.png";
import menu_remote from "../../assets/images/icon/gwsd/menu_remote.png";
import sim_remote from "../../assets/images/icon/gwsd/sim_remote.png";
import menu_sim_info from "../../assets/images/icon/menu_sim_info.png";
import site_icon from "../../assets/images/icon/site_icon.png";
import ipv_list_icon from "../../assets/images/icon/gwsd/menu_ipv_list.png"
const userMsg =
    sessionStorage.getItem("loginMsg") &&
    JSON.parse(sessionStorage.getItem("loginMsg"));
const userData = [
    {
        icon: menu_user_list,
        text: `用户列表`,
        type: "1-1",
    },
    // {
    //     icon: menu_user_list,
    //     text: `扫码巡更`,
    //     type: "1-5",
    // },
    {
        icon: menu_saoyisao,
        text: `扫描IMEI`,
        type: "1-3",
    },
    {
        icon: menu_add_user,
        text: `用户添加`,
        type: "1-2",
    },
    {
        icon: sim_remote,
        text: `ICCID放号`,
        type: "1-7",
    },
    {
        icon: menu_remote,
        text: `绑定IMEI号`,
        type: "1-6",
    },
    {
        icon: site_icon,
        text: `定位`,
        type: "1-8"
    },
    {
        icon: menu_saoyisao,
        text: `扫描ICCID`,
        type: "1-9",
    },
    {
        icon: menu_bill_record,
        text: `迁移记录`,
        type: "1-4",
    }
];
const groupData = [
    {
        icon: menu_group_list,
        text: `群组列表`,
        type: "2-1",
    },
    {
        icon: menu_group_add,
        text: `群组添加`,
        type: "2-2",
    },
    // {
    //     icon: menu_group_combination,
    //     text: `群组关联`,
    //     type: "2-3",
    // },

    {
        icon: menu_group_prefix_list,
        text: `前缀列表`,
        type: "2-4",
    },
];

const billData = [
    // {
    //     icon: menu_bill_record,
    //     text: `账单列表`,
    //     type: "3-1",
    // },
    {
        icon: menu_bill_message,
        text: `虚拟币信息`,
        type: "3-2",
    },
    // {
    //     icon: menu_bill_exchange,
    //     text: `账单置换`,
    //     type: "3-3",
    // },
    {
        icon: menu_bill_record,
        text: `虚拟币记录`,
        type: "3-4",
    },
];

const adminData = [
    {
        icon: admin_list,
        text: `管理员列表`,
        type: "4-1",
    },
    {
        icon: admin_add,
        text: `添加管理员`,
        type: "4-2",
    },
    {
        icon: menu_recycle_bin,
        text: `回收管理员`,
        type: "4-3",
    },
];
const enterpriseAdminData = [
    {
        icon: admin_list,
        text: `企业管理列表`,
        type: '6-1'
    },
    {
        icon: menu_group_list,
        text: `企业群组`,
        type: '6-2'
    },
    {
        icon: menu_user_list,
        text: `企业用户`,
        type: '6-3'
    },
];
const simData = [
    // {
    //     icon: menu_sim_info,
    //     text: `卡号   信息查询`,
    //     type: "5-1"
    // },
    // {
    //     icon: menu_group_combination,
    //     text: `DMR中转台`,
    //     type: "5-2"
    // }
    {
       icon:  ipv_list_icon,
       text: '音柱列表',
       type: '5-3'
    },
];

const PlaceHolder = ({ className = '', ...restProps }) => (
    <div className={`${className} placeholder`} {...restProps}>{version}</div>
);

/**
 * userMsg.userType  管理员等级
 * 0为系统管理员
 * 1为总管理员
 * 2为一级管理员
 * 3为二级管理员
 * 4为三级管理员
 * 5为子调度终端账号
 * userMsg.permissionCodeList  管理员的权限列表
 *  204 为 远程放号
 *  201 为 修改账号信息
 *  203 为 查看密码
 *  202 为 删除账号
 *  205 为 功能设置
 */

// // 菜单控制 判断当前管理员是否为 总/一级/二级管理员
// if (!(userMsg && (userMsg.userType < 0 || userMsg.userType > 3))) {
//     // billData.shift();
//     userData.splice(1, 4);
//     console.log(userData,'总/一级/二级')
//     groupData.pop();
//     groupData.pop();
// }
// // 菜单控制 判断当前是否为非二级管理员
// if (userMsg && (userMsg.userType != 3)) {
//     userData.pop();
//     console.log(userData,'非二级')
// }
// // 菜单控制 判断当前是否为系统管理员
// if (userMsg && userMsg.userType == 0) {
//     userData.splice(1, 1);
//     // userData.pop();
//     console.log(userData,'系统')
// }
// console.log(userMsg,1111)
// // 菜单控制 判断当前是否为三级管理员并且拥有204(远程修改)权限
// if (userMsg && userMsg.userType == 4 && userMsg.permissionCodeList && !userMsg.permissionCodeList.includes(204)) {
//     userData.pop();
//     console.log('三级204', userData)
// }

// 
if (userMsg && (userMsg.userType >= 0 && userMsg.userType < 3)) {
    userData.splice(1)
} else if (userMsg && userMsg.userType == 3) {
    userData.splice(1, 7)
    console.log('二级', userData)
} else if (userMsg && userMsg.userType == 4) {
    // 去除迁移记录
    userData.pop()
    console.log('三级', userData)
} else if (userMsg && userMsg.userType == 5) {
    // 子调度账号只显示 用户列表与定位菜单
    userData.splice(1, 4)
    userData.pop()
    userData.pop()
}

if (userMsg && userMsg.userType == 4 && userMsg.permissionCodeList && !userMsg.permissionCodeList.includes(204)) {
    // 去除扫码放号菜单
    // userData.splice(1,1)
    // 去除绑定IMEI号菜单
    userData.splice(3, 1)
    console.log('三级204权限', userData)
}

@connect(({ app }) => ({ app }))
export class Menu extends Component {
    state = {
        notice: "",
    };
    componentDidMount () {
        this.props.deleteSelectUserList();
        this.props.emptySelectGroup();
        this.getNotice();
        sessionStorage.removeItem("userListPage");
    }
    getNotice () {
        axios.get("/api/info/notice/get").then(res => {
            if (res && res.status == 200 && res.data) {
                this.setState({
                    notice: res.data,
                });
            }
        });
    }
    handleClick (e) {
        console.log(e, this.props, 111);
        let url = "";
        switch (e.type) {
            case "1-1":
                url = "/userlist";
                break;
            case "1-5":
                url = "/Clockin";
                break;
            case "1-3":
                url = "/clockinsdk";
                break;
            case "1-2":
                url = "/adduser";
                break;
            case "1-4":
                url = "/transferUsersRecord";
                break;
            case "1-6":
                url = "/bindingImei";
                break;
            case "1-7":
                url = "/bindingIccid";
                break;
            case "1-8":
                url = "/locationMsg";
                break;
            case "1-9":
                url = '/clockinICCID';
                break;
            case "1-10":
                return;
            case "2-1":
                url = "/grouplist";
                break;
            case "2-2":
                url = "/addgroup";
                break;
            case "2-3":
                url = "/groupcombination";
                break;
            case "2-4":
                url = "/groupPrefixList";
                break;
            case "3-1":
                url = "/billlist";
                break;
            case "3-2":
                url = "/billmessage";
                break;
            case "3-3":
                url = "/billexchange";
                break;
            case "3-4":
                url = "/currencyrecord";
                break;

            case "4-1":
                url = "/adminlist";
                break;
            case "4-2":
                url = "/addadmin";
                break;
            case "4-3":
                url = "/adminretrieve";
                break;
            case "5-1":
                url = "/simInfo";
                break;
            case "5-2":
                url = "/theturntableList";
                break;
            case "5-3":
                url = '/ipvInfo'
                break
            case "6-1":
                url = '/enterprise/admin/enterpriseAdminList'
                break
            case "6-2":
                url = '/enterprise/group/enterpriseGroupList'
                break
            case "6-3":
                url = '/enterprise/user/enterpriseUserList'
                break
            default:
                break;
        }
        this.props.history.push(url);
    }
    loginOut = () => {
        const BUTTONS = ["确定", "取消"];
        ActionSheet.showActionSheetWithOptions(
            {
                options: BUTTONS,
                cancelButtonIndex: 1,
                destructiveButtonIndex: 0,
                message: "是否注销登录？",
                maskClosable: true,
            },
            buttonIndex => {
                if (buttonIndex == 0) {
                    Toast.loading("退出登录中...", 1);
                    setTimeout(() => {
                        sessionStorage.removeItem("loginMsg", "");
                        Toast.success("注销成功", 1, () => {
                            window.location.reload();
                        });
                    }, 1000);
                }
            },
        );
    };
    adminLevelName = () => {
        const userMsg =
            sessionStorage.getItem("loginMsg") &&
            JSON.parse(sessionStorage.getItem("loginMsg"));
        if (userMsg.userType == 0) {
            return "系统管理员";
        } else if (userMsg.userType == 1) {
            return "总管理员";
        } else if (userMsg.userType == 2) {
            return "一级管理员";
        } else if (userMsg.userType == 3) {
            return "二级管理员";
        } else if (userMsg.userType == 4) {
            return "三级管理员";
        } else if (userMsg.userType == 5) {
            return "子调度账号"
        }
    };
    render () {
        const { app } = this.props;
        const { currencyTotalCount, currencyUsedCount,permanentCurrencyCount } = app;
        const userMsg =
            sessionStorage.getItem("loginMsg") &&
            JSON.parse(sessionStorage.getItem("loginMsg"));
        return (
            <div className="menu" style={{ paddingBottom: 50 }}>
                <div className="header-sticky">
                    <NavBar mode="dark">公网对讲调度管理平台</NavBar>
                </div>
                <div className="sub-container">
                    <WingBlank>
                        <div>
                            <WhiteSpace size="lg" />
                            {userMsg.userType == 5 ? (
                                <Card>
                                    <Card.Header
                                        title={userMsg.loginName}
                                        thumb={admin_list}
                                    />
                                    <Card.Body
                                        extra={
                                            <span size="small">安全退出</span>
                                        }>
                                        <div>{this.adminLevelName()}</div>
                                    </Card.Body>
                                    <Card.Footer
                                        extra={
                                            <span
                                                size="small"
                                                onClick={() => this.loginOut()}
                                            >
                                                安全退出
                                            </span>
                                        }
                                    />
                                </Card>
                            ) : (
                                <Card>
                                    <Card.Header
                                        title={userMsg.loginName}
                                        thumb={admin_list}
                                        extra={
                                            <div
                                                onClick={() =>
                                                    this.props.history.push(
                                                        `/addadmin/${userMsg.loginName}/edit/${userMsg.id}`,
                                                    )
                                                }
                                            >
                                                <Icon type="right" />
                                            </div>
                                        }
                                    />
                                    <Card.Body
                                        extra={
                                            <span size="small">安全退出</span>
                                        }>
                                        <div>{this.adminLevelName()}</div>
                                        <div>可用虚拟币: {currencyTotalCount - currencyUsedCount}</div>
                                        <div>已用虚拟币: {currencyUsedCount}</div>
                                        <div>可用终身币: {permanentCurrencyCount}</div>
                                    </Card.Body>
                                    <Card.Footer
                                        extra={
                                            <span
                                                size="small"
                                                onClick={() => this.loginOut()}
                                            >
                                                安全退出
                                            </span>
                                        }
                                    />
                                </Card>
                            )}

                        </div>
                        <div className="list-item">
                            <div className="title">用户管理</div>
                            <div>
                                <Grid
                                    data={userData}
                                    columnNum={2}
                                    square={false}
                                    onClick={e => this.handleClick(e)}
                                />
                            </div>
                        </div>
                        {userMsg.userType == 4 ? (
                            <div className="list-item">
                                <div className="title">群组管理</div>
                                <div>
                                    <Grid
                                        data={groupData}
                                        columnNum={2}
                                        square={false}
                                        onClick={e => this.handleClick(e)}
                                    />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {billData.length > 0 && userMsg.userType < 5 ? (
                            <div className="list-item">
                                <div className="title">虚拟币管理</div>
                                <div>
                                    <Grid
                                        data={billData}
                                        columnNum={2}
                                        square={false}
                                        onClick={e => this.handleClick(e)}
                                    />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {userMsg.userType == 4 ? (
                            <div className="list-item">
                                <div className="title">设备管理</div>
                                <div>
                                    <Grid
                                        data={simData}
                                        columnNum={2}
                                        square={false}
                                        onClick={e => this.handleClick(e)}
                                    />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {userMsg.userType < 4 && userMsg.userType >= 0 ? (
                            <div className="list-item">
                                <div className="title">管理员管理</div>
                                <div>
                                    <Grid
                                        data={adminData}
                                        columnNum={adminData.length}
                                        square={false}
                                        onClick={e => this.handleClick(e)}
                                    />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {userMsg.userType < 4 && userMsg.userType >= 0 ? (
                            <div className="list-item">
                                <div className="title">企业管理</div>
                                <div>
                                    <Grid
                                        data={enterpriseAdminData}
                                        columnNum={enterpriseAdminData.length}
                                        square={false}
                                        onClick={e => this.handleClick(e)}
                                    />
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        <WhiteSpace size="xl" />
                        <PlaceHolder />
                    </WingBlank>
                    <div className="header-sticky header-notice">
                        {this.state.notice ? (
                            <NoticeBar
                                marqueeProps={{
                                    loop: true,
                                    style: { padding: "0 7.5px" },
                                }}
                                mode="closable"
                            >
                                {this.state.notice}
                            </NoticeBar>
                        ) : (
                            ""
                        )}
                    </div>
                    <WhiteSpace size="lg" />
                    <WhiteSpace size="lg" />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        prop: state.prop,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        emptySelectGroup: () => {
            dispatch({
                type: "group/emptyGroups",
            });
        },
        deleteSelectUserList: () => {
            dispatch({
                type: "userSelectList/deleteSelectUserList",
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
